import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=11ded066&scoped=true"
import script from "./EditDepartment.vue?vue&type=script&lang=ts"
export * from "./EditDepartment.vue?vue&type=script&lang=ts"
import style0 from "./EditDepartment.vue?vue&type=style&index=0&id=11ded066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ded066",
  null
  
)

export default component.exports